import { useEffect } from 'react'

interface ModalProps {
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
    showCloseButton?: boolean
}

export const Modal = ({ isOpen, onClose, children, showCloseButton = true }: ModalProps): JSX.Element | null => {
    // 按 ESC 鍵關閉彈窗
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener('keydown', handleEsc)
            // 防止背景滾動
            document.body.style.overflow = 'hidden'
        }

        return () => {
            document.removeEventListener('keydown', handleEsc)
            document.body.style.overflow = 'unset'
        }
    }, [isOpen, onClose])

    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-3 py-4 md:p-4">
            {/* 背景遮罩 */}
            <div
                className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
                onClick={onClose}
            />

            {/* 彈窗內容容器 - 响应式 */}
            <div className="relative z-10 max-h-[90vh] overflow-y-auto">
                {/* 關閉按鈕 - 相對於內容定位 */}
                {showCloseButton && (
                    <button
                        onClick={onClose}
                        className="absolute top-2 right-2 md:top-4 md:right-4 z-20 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                        aria-label="關閉"
                    >
                        <svg
                            className="w-4 h-4 md:w-5 md:h-5 text-gray-600"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                )}
                {children}
            </div>
        </div>
    )
}

